import { Tag } from 'antd';
import dayjs from 'dayjs';
import { userRoles } from '../../utils/constants/tagColors';
import { formatPhoneNumber } from '../../utils/formatPhoneNumber';

export const useListContent = (t, data = {}) => {
  const {
    first_name,
    last_name,
    role,
    email,
    phone_number,
    address,
    cell_phone_number
  } = data;
  const { number, street, city, postal_code, country } = address || {};

  return [
    {
      label: 'users.form.last_name',
      span: 1,
      content: last_name || '-'
    },
    {
      label: 'users.form.first_name',
      span: 1,
      content: first_name || '-'
    },
    {
      label: 'users.form.status',
      span: 1,
      content:
        (role && (
          <Tag color={userRoles[role.split(':')[1]]}>
            {t(`users.tags.${role.split(':')[1]}`)}
          </Tag>
        )) ||
        '-'
    },
    {
      label: 'users.form.email',
      span: 1,
      content: email || '-'
    },
    {
      label: 'users.form.cell_phone_number_full',
      span: 1,
      content: cell_phone_number?.number ? (
        <div>{formatPhoneNumber(cell_phone_number)}</div>
      ) : (
        '-'
      )
    },
    {
      label: 'users.form.phone_number_full',
      span: 1,
      content: phone_number?.number ? (
        <div>{formatPhoneNumber(phone_number)}</div>
      ) : (
        '-'
      )
    },
    {
      label: 'users.form.postal_address',
      span: 1,
      content:
        (address &&
          `${number || ''} ${street || ''} ${postal_code || ''} ${city || ''} ${
            country || ''
          }`) ||
        '-'
    },
    {
      label: 'users.form.created_at',
      span: 1,
      content:
        (data.created_at && dayjs(data.created_at).format('DD/MM/YYYY')) || '-'
    }
  ];
};
